// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Paraguay */
const PY = /^(?:9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\d{6})$/;

export default PY;
